// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VWEN","newExpiryDate":"styles_newExpiryDate__2ORcD","footer":"styles_footer__4yNbi"};